import React, {Component} from "react";
import PropTypes from "prop-types";
import {UnibuddyLogoHeader} from "shared/Navigation/components/UnibuddyLogoHeader/UnibuddyLogoHeader";
import ExternalHeaderRoutes from "./ExternalHeaderRoutes";
import {AppContainer} from "../../../../../shared/components/Containers/AppContainer";

class ExternalHeader extends Component {
    onOpenUnibuddy() {
        const toReplace = this.props.location.pathname.split("/").slice(0, 5).join("/");
        const path = this.props.location.pathname.split("/").slice(0, 4).join("/");
        window.open(this.props.location.pathname.replace(toReplace, `/embed${path}`), "_blank");
    }

    onBack = (e) => {
        e.stopPropagation();
        this.props.history.replace(this.props.carouselUrl);
    };

    render() {
        return (
            <div>
                <UnibuddyLogoHeader
                    onClick={this.onOpenUnibuddy.bind(this)}
                    onBack={this.onBack}
                    showBackButton={this.props.isCarousel}
                />
                {this.props.isCarousel ? (
                    <AppContainer data-test-id="narrow-container">
                        <ExternalHeaderRoutes {...this.props} />
                    </AppContainer>
                ) : (
                    <ExternalHeaderRoutes {...this.props} />
                )}
            </div>
        );
    }
}

ExternalHeader.propTypes = {
    carouselUrl: PropTypes.string.isRequired,
    isCarousel: PropTypes.bool,
};

ExternalHeader.defaultProps = {
    isCarousel: false,
};

export default ExternalHeader;
